<template>
  <v-card>
    <v-card-title class="align-center justify-center primary white--text mb-4">Historique</v-card-title>
    <v-card-text>
      <v-skeleton-loader v-if="loading" type="table-tbody" />
      <v-data-table
        v-else
        :headers="headers"
        :items="contractValidityHistory"
        :items-per-page="5"
      >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { format, fromUnixTime } from 'date-fns';
import { fr } from 'date-fns/locale';
import { requests, EventBus } from '@/mixins/index';

export default {
  components: { },
  mixins: [requests],
  props: {
    contract: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      contractValidityHistory: [],
      loading: false,
      headers: [
        { text: 'Date de modification de la date d\'expiration du contrat', value: 'date', width: '30%', align: 'center' },
        { text: 'Date d\'expiration précédente', value: 'oldDate', width: '20%', align: 'center' },
        { text: 'Nouvelle date d\'expiration', value: 'newDate', width: '20%', align: 'center' },
        { text: 'Collaborateur', value: 'collaboratorUuid', width: '30%', align: 'center' }
      ]
    };
  },
  async mounted () {
    await this.loadContractValidityHistory();
  },
  methods: {
    computeContractValidityHistory (array) {
      return array.map(item => ({
        ...item,
        date: format(fromUnixTime(item.timestamp), 'dd/MM/yyyy HH:mm', { locale: fr }),
        oldDate: format(new Date(item.oldEndDate), 'dd/MM/yyyy HH:mm', { locale: fr }),
        newDate: format(new Date(item.newEndDate), 'dd/MM/yyyy HH:mm', { locale: fr })
      })).sort((a, b) => (a.timestamp > b.timestamp ? -1 : 1));
    },
    async loadContractValidityHistory () {
      if (!this.$props.contract || !this.$props.contract.contractNumber) {
        return;
      }

      this.loading = true;
      const response = await this.getContractValidityHistory(this.$props.contract.contractNumber);
      this.loading = false;

      const notification = {
        message: response.success ? 'Historique des modifications du contrat récupéré avec succès' : 'Erreur lors de la récupération de l\'historique des modifications du contrat',
        type: response.success ? 'success' : 'danger',
        timeout: 10000
      };
      EventBus.$emit('show-notifications', [notification]);

      if (response.success && response.data) {
        this.contractValidityHistory = this.computeContractValidityHistory(response.data);
      }
      EventBus.$emit('up-to-date-contract-validity-history', true);
    }
  }
};
</script>
